export const notificationType = {
  CRITICAL: 'critical',
  NON_CRITICAL: 'non-critical',
};
